import { render, staticRenderFns } from "./KeyNumbers.vue?vue&type=template&id=50ec15be&scoped=true&"
import script from "./KeyNumbers.vue?vue&type=script&lang=ts&"
export * from "./KeyNumbers.vue?vue&type=script&lang=ts&"
import style0 from "./KeyNumbers.vue?vue&type=style&index=0&id=50ec15be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec15be",
  null
  
)

export default component.exports